import { createAction, props, union } from '@ngrx/store';

import { ABTest } from '../../declarations/ab-test';

// Historique complet des tests A/B de la source courante (scheduled/running/finished), chargé une seule fois par
// source pour alimenter le toggle "édition Test AB" sans que chaque toolbar ne refasse son propre appel réseau.
export const loadABTests = createAction(
  '[NEWSLETTERS][AB_TEST] Load list',
  props<{ tests: ABTest[] }>()
);

// Test A/B choisi via le toggle "édition Test AB" : `test: null` = toggle désactivé, on édite la source live.
export const selectABTestForEditing = createAction(
  '[NEWSLETTERS][AB_TEST] Select for editing',
  props<{ test: ABTest | null }>()
);

const abTestActions = union({
  loadABTests,
  selectABTestForEditing
});

export type ABTestAction = typeof abTestActions;
